import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import {
  Alert,
  Box,
  Button,
  Container,
  Grid,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Stack,
  Typography,
} from '@mui/material';

import DynamicBreadcrumbs from '@/components/nav/Breadcrumb';
import ResourcesRightSidebar from '@/components/nav/ResourcesRightSidebar';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const Form1125A = () => {
  return (
    <AppLayout
      meta={
        <Meta
          title="IRS Form 1125-A Cost of Goods Sold | TaxZerone"
          description="File IRS Form 1125-A to report Cost of Goods Sold (COGS) with your Form 1120-S. Learn who must file, how to complete it, and e-file easily with TaxZerone."
          keywords=""
          canonical="resources/business-tax/form-1125-a/"
          ogType="article"
          jsonLdPricing="179.99"
          jsonLdAggregateRatingValue="4.97"
          jsonLdAggregateRatingCount="1658"
        />
      }
    >
      <Container maxWidth="lg" sx={{ textAlign: 'center' }}>
        <Typography
          variant="h1"
          sx={{
            fontSize: { lg: 40, md: 36, sm: 32, xs: 24 },
            fontWeight: 600,
            mb: 5,
            mt: 5,
            textAlign: 'center',
          }}
        >
          IRS{' '}
          <span className="highlight-container">
            <span className="highlight">Form 1125-A</span>
          </span>{' '}
          Cost of Goods Sold (COGS)
        </Typography>
        {/* <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            mt: 1,
            mb: 2,
          }}
        >
          E-File your IRS <span style={{ fontWeight: 600 }}> Form 1120-S</span>{' '}
          for the 2024 tax year by{' '}
          <span style={{ fontWeight: 600 }}>March 17, 2025,</span> to meet
          federal S
          <Hidden smDown>
            {' '}
            <br />
          </Hidden>{' '}
          corporation filing deadlines and avoid potential penalties.
        </Typography>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Button
            variant="contained"
            className="btn-primary medium"
            sx={{
              fontSize: {
                xs: '16px !important',
                sm: '18px !important',
                lg: '24px !important',
              },
              transition: 'all 0.3s ease 0s',
              '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
            }}
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=1120sduedates`}
          >
            E-file Now!
          </Button> */}
        {/* </Box> */}
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          py: 5,
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        mt={0}
      >
        <Container maxWidth="lg" sx={{ mb: 0 }}>
          <DynamicBreadcrumbs />
          <Grid
            container
            spacing={0}
            rowSpacing={0}
            m={0}
            sx={{ flexDirection: 'row-reverse' }}
          >
            <Grid
              size={{ xs: 12, md: 3.5, sm: 4.5 }}
              sx={{ display: { xs: 'none', sm: 'block' } }}
            >
              <ResourcesRightSidebar />
            </Grid>
            <Grid size={{ xs: 12, md: 8.5, sm: 7.5 }}>
              <Paper
                variant="outlined"
                sx={{
                  border: '1px solid #ccc',
                  p: 3,
                  px: 3,
                  textAlign: 'left',
                  mb: 0,
                  minHeight: '100%',
                }}
              >
                <Box
                  component="article"
                  itemScope
                  itemType="https://schema.org/Article"
                  sx={{
                    p: 3,
                    px: 3,
                    backgroundColor: '#f0f5f8',
                    borderLeft: '5px solid #01456c',
                    mb: 4,
                    borderRadius: 3,
                    position: 'relative',
                  }}
                >
                  <link
                    itemProp="mainEntityOfPage"
                    href="https://www.taxzerone.com/resources/business-tax/form-1125-a/"
                  />
                  {/* Article requires an image */}
                  <div
                    itemProp="image"
                    itemScope
                    itemType="https://schema.org/ImageObject"
                    style={{ display: 'none' }}
                  >
                    <link
                      itemProp="url"
                      href="https://www.taxzerone.com/assets/images/logo.webp"
                    />
                    <data itemProp="width" value="380" />
                    <data itemProp="height" value="124" />
                  </div>
                  <Box
                    sx={{
                      display: 'grid',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      textAlign: 'left',
                      mb: 2,
                    }}
                  >
                    <Typography variant="body2">
                      Last updated:{' '}
                      <time
                        itemProp="datePublished"
                        dateTime="2026-08-25T09:00:00-05:00"
                      >
                        Aug 25, 2026
                      </time>
                      <time
                        itemProp="dateModified"
                        dateTime="2026-08-25T09:00:00-05:00"
                        style={{ display: 'none' }}
                      >
                        Aug 25, 2026
                      </time>
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 600 }}
                      itemProp="author"
                      itemScope
                      itemType="https://schema.org/Person"
                    >
                      -by{' '}
                      <span itemProp="name">
                        <a
                          itemProp="url"
                          href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}`}
                          style={{
                            color: 'inherit',
                            textDecoration: 'none',
                          }}
                        >
                          Nikhil Chowdary
                        </a>
                      </span>{' '}
                      | TaxZerone
                    </Typography>
                  </Box>
                  <Typography
                    component="h2"
                    itemProp="headline"
                    variant="h4"
                    sx={{
                      fontWeight: 600,
                      mb: 0.8,
                      fontSize: { md: 20, sm: 18, xs: 16 },
                      color: '#01456c',
                      fontStyle: 'italic',
                    }}
                  >
                    IRS Form 1125-A at a glance
                  </Typography>

                  <Box
                    component="ul"
                    itemScope
                    itemType="https://schema.org/ItemList"
                    sx={{
                      mb: 0,
                      pl: 0,
                      listStyle: 'none',
                      '& li': { mb: 1.6, position: 'relative', pl: 3 },
                      '& li::before': {
                        content: '"★"',
                        position: 'absolute',
                        left: 0,
                        top: '-2px',
                        color: '#01456c',
                        fontSize: '18px',
                      },
                    }}
                  >
                    <li
                      itemProp="itemListElement"
                      itemScope
                      itemType="https://schema.org/ListItem"
                    >
                      <meta itemProp="position" content="1" />
                      <span itemProp="name">
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Understand the purpose of IRS Form 1125-A
                        </strong>{' '}
                        and how businesses calculate and report Cost of Goods
                        Sold (COGS) on Form 1065, Form 1120, and Form 1120-S.
                      </span>
                    </li>
                    <li
                      itemProp="itemListElement"
                      itemScope
                      itemType="https://schema.org/ListItem"
                    >
                      <meta itemProp="position" content="2" />
                      <span itemProp="name">
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Learn who must file Form 1125-A
                        </strong>{' '}
                        and how inventory requirements apply to partnerships, S
                        corporations, and corporations that manufacture or sell
                        products.
                      </span>
                    </li>
                    <li
                      itemProp="itemListElement"
                      itemScope
                      itemType="https://schema.org/ListItem"
                    >
                      <meta itemProp="position" content="3" />
                      <span itemProp="name">
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Explore Form 1125-A line-by-line instructions,
                        </strong>{' '}
                        including beginning inventory, purchases, labour costs,
                        Section 263A costs, other expenses, ending inventory,
                        and COGS calculation.
                      </span>
                    </li>
                    <li
                      itemProp="itemListElement"
                      itemScope
                      itemType="https://schema.org/ListItem"
                    >
                      <meta itemProp="position" content="4" />
                      <span itemProp="name">
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Understand inventory valuation methods and IRS rules,
                        </strong>{' '}
                        including cost method, lower of cost or market, LIFO,
                        and Section 263A capitalization requirements.
                      </span>
                    </li>
                  </Box>
                </Box>
                <Stack
                  direction={{ xs: 'column-reverse', md: 'row' }}
                  spacing={{ xs: 1, sm: 2, md: 3 }}
                  sx={{ mb: 0 }}
                >
                  <Box>
                    <Typography variant="body1" sx={{ mb: 2 }}>
                      If your business manufactures products or purchases
                      inventory for resale,{' '}
                      <strong style={{ fontWeight: 600 }}>
                        {' '}
                        IRS Form 1125-A
                      </strong>{' '}
                      helps you calculate and report your{' '}
                      <strong style={{ fontWeight: 600 }}>
                        {' '}
                        Cost of Goods Sold (COGS)
                      </strong>{' '}
                      when filing{' '}
                      <strong style={{ fontWeight: 600 }}>
                        <Link
                          href="/business-tax/efile-irs-form-1065-online/"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form 1065
                        </Link>
                        , Form 1120, or{' '}
                        <Link
                          href="/business-tax/efile-irs-form-1120-s/"
                          sx={{ color: '#0202ff' }}
                        >
                          Form 1120-S
                        </Link>
                        .
                      </strong>{' '}
                      Accurately reporting inventory costs is essential because
                      COGS directly affects your taxable income.
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      This guide explains who must file Form 1125-A, the
                      information required to complete it, how inventory is
                      calculated, filing requirements, and common mistakes to
                      avoid. Whether you're a partnership or corporation, Ta
                      xZerone provides the resources you need to prepare your
                      business tax return with confidence and stay compliant
                      with IRS requirements.
                    </Typography>
                  </Box>
                  <Box
                    sx={{ mb: 1, textAlign: { xs: 'center', md: 'left' } }}
                  />
                </Stack>
                <Box
                  sx={{
                    pt: 0,
                  }}
                >
                  <Typography variant="body1" sx={{ mb: 0.5 }}>
                    <b>Table of Contents</b>
                  </Typography>
                  <List
                    sx={{ mb: 5, border: '1px solid #ccc', borderRadius: 2 }}
                  >
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#whomust" sx={{ color: '#0202ff' }}>
                          Who Must File Form 1125-A?
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#deadlines" sx={{ color: '#0202ff' }}>
                          Filing Deadlines for Form 1125-A
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#purpose" sx={{ color: '#0202ff' }}>
                          Purpose of Form 1125-A
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#step" sx={{ color: '#0202ff' }}>
                          Step-by-Step Guide to Form 1125-A Completio
                        </Link>
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#required" sx={{ color: '#0202ff' }}>
                          Required Documentation
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#common" sx={{ color: '#0202ff' }}>
                          Common Pitfalls and Penalties
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#key" sx={{ color: '#0202ff' }}>
                          Key Tips for Compliance
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#faqs" sx={{ color: '#0202ff' }}>
                          Frequently Asked Questions (FAQs)
                        </Link>
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="whomust"
                >
                  Who Must File Form 1125-A?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Form 1125-A is mandatory for businesses maintaining physical
                  inventory for resale or production of goods, including:
                </Typography>

                <Typography variant="body1" sx={{ mb: 1 }}>
                  You must file Form 1125-A if:
                </Typography>

                <Box component="ul" sx={{ '& li': { mb: 1.5 }, mb: 3 }}>
                  <li>
                    Your business{' '}
                    <span style={{ fontWeight: 600 }}>produces goods</span> or{' '}
                    <span style={{ fontWeight: 600 }}>
                      purchases goods for resale
                    </span>
                    , and
                  </li>
                  <li>
                    You{' '}
                    <span style={{ fontWeight: 600 }}>
                      maintain an inventory
                    </span>{' '}
                    during the tax year.
                  </li>
                </Box>

                <Typography variant="body1" sx={{ mb: 2 }}>
                  Entities required to complete this form include:
                </Typography>

                <Box component="ul" sx={{ '& li': { mb: 1.5 }, mb: 1.5 }}>
                  <li>C Corporations filing Form 1120 </li>
                  <li>
                    S Corporations{' '}
                    <Link
                      href="/business-returns/efile-irs-form-1120-s/"
                      sx={{ color: '#0202ff' }}
                    >
                      {' '}
                      filing Form 1120-S
                    </Link>
                  </li>
                  <li>Partnerships filing Form 1065 </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 4 }}>
                  Service-based businesses that don’t maintain an inventory
                  (like consultants, designers, or marketing agencies){' '}
                  <span style={{ fontWeight: 600 }}>don’t need to file</span>{' '}
                  Form 1125-A.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="deadline"
                >
                  Filing Deadlines for Form 1125-A
                </Typography>

                <Typography variant="body1" sx={{ mb: 1 }}>
                  The deadline for submitting Form 1125-A depends on the filing
                  due date of the main return it’s attached to:
                </Typography>
                <Box component="ul" sx={{ mb: 1.2, '& li': { mb: 1.2 } }}>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      C Corporations (Form 1120):
                    </span>{' '}
                    April 15, 2026{' '}
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      S Corporations (Form 1120-S):
                    </span>{' '}
                    March 16, 2026
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Partnerships (Form 1065):
                    </span>{' '}
                    March 16, 2026
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 4 }}>
                  If you need more time, you can file an{' '}
                  <span style={{ fontWeight: 600 }}>extension</span> using{' '}
                  <Link
                    href="/tax-extension/efile-irs-form-7004-business-tax-extension-online/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Form 7004
                  </Link>{' '}
                  before the original due date.
                </Typography>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="purpose"
                >
                  Purpose of Form 1125-A
                </Typography>

                <Box component="ul" sx={{ '& li': { mb: 1.5 }, mb: 2 }}>
                  <li>
                    Provides a clear computation for deducting the cost of goods
                    sold, which directly affects taxable income and gross profit
                    reporting.
                  </li>
                  <li>
                    Ensures businesses accurately comply with IRS inventory and
                    cost capitalization rules, such as Section 263A.
                  </li>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="step"
                >
                  Step-by-Step Guide to Form 1125-A Completion
                </Typography>
                <picture>
                  <source srcSet="/assets/images/f1125a-cost-good-img.webp" />
                  <source srcSet="/assets/images/f1125a-cost-good-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/f1125a-cost-good-img.png"
                    loading="lazy"
                    alt="IRS Form 1125-A Cost of Goods Sold attached to Forms 1120, 1120-C, 1120-F, 1120-S, and 1065"
                    width={760}
                    height={492}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 19, sm: 18, xs: 17 },
                    fontWeight: 600,
                    mb: 0.5,
                  }}
                >
                  Line 1 – Inventory at Beginning of Year
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    Enter the total value of inventory available at the
                    beginning of the tax year. This amount is generally the same
                    as the prior year’s ending inventory.{' '}
                  </li>
                  <li>
                    If you change your accounting method, enter the recalculated
                    beginning inventory using the new method and attach an
                    explanation for any required Section 481(a) adjustment.
                  </li>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 19, sm: 18, xs: 17 },
                    fontWeight: 600,
                    mb: 0.5,
                  }}
                >
                  Line 2 – Purchases
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    Enter the total cost of inventory purchased during the tax
                    year for resale or production. Reduce the amount by any
                    items withdrawn for personal use, returns, allowances, or
                    discounts.
                  </li>
                  <li>
                    For partnerships, personal-use items should be reported as
                    distributions to partners on{' '}
                    <Link
                      href="/resources/business-tax/schedule-k/"
                      sx={{ color: '#0202ff' }}
                    >
                      {' '}
                      Schedule K{' '}
                    </Link>{' '}
                    and{' '}
                    <Link
                      href="/resources/business-tax/schedule-k-1/"
                      sx={{ color: '#0202ff' }}
                    >
                      {' '}
                      Schedule K-1
                    </Link>
                    .
                  </li>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 19, sm: 18, xs: 17 },
                    fontWeight: 600,
                    mb: 0.5,
                  }}
                >
                  Line 3 – Cost of Labor
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    Enter the direct labor costs incurred to produce or
                    manufacture goods during the tax year. Include wages and
                    related costs for employees directly involved in production.
                  </li>
                  <li>
                    Do not include indirect labor costs unless required under
                    Section 263A.
                  </li>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 19, sm: 18, xs: 17 },
                    fontWeight: 600,
                    mb: 0.5,
                  }}
                >
                  Line 4 – Additional Section 263A Costs
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    Enter any additional Section 263A costs that must be
                    included in inventory but are not reported on Lines 2, 3, or
                    5.
                  </li>
                  <li>
                    These may include certain production, storage, purchasing,
                    handling, or administrative costs. Attach a schedule with
                    the details of these costs.
                  </li>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 19, sm: 18, xs: 17 },
                    fontWeight: 600,
                    mb: 0.5,
                  }}
                >
                  Line 5 – Other Costs
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    Enter any additional inventory costs paid or incurred during
                    the tax year that are not included on Lines 2 through
                    4.{' '}
                  </li>
                  <li>
                    Attach a statement listing the details of these costs. For
                    cooperatives, please include eligible per-unit retain
                    allocations and provide the required details.
                  </li>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 19, sm: 18, xs: 17 },
                    fontWeight: 600,
                    mb: 0.5,
                  }}
                >
                  Line 6 – Total
                </Typography>

                <Typography variant="body1" sx={{ mb: 2 }}>
                  Add Lines 1 through 5 and enter the total cost of inventory
                  available for sale or production during the tax year.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 19, sm: 18, xs: 17 },
                    fontWeight: 600,
                    mb: 0.5,
                  }}
                >
                  Line 7 – Inventory at End of Year
                </Typography>

                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the value of inventory remaining at the end of the tax
                  year. Include any required Section 263A costs when determining
                  the ending inventory amount.
                </Typography>
                <Alert
                  icon={false}
                  severity="warning"
                  sx={{ mt: 0, mb: 4, borderLeft: '3px solid rgb(102, 60, 0)' }}
                  id="filing"
                >
                  <b>Note :</b>
                  <i>
                    {' '}
                    Follow the applicable inventory valuation rules to calculate
                    the correct amount.
                  </i>
                </Alert>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 19, sm: 18, xs: 17 },
                    fontWeight: 600,
                    mb: 0.5,
                  }}
                >
                  Line 8 – Cost of Goods Sold
                </Typography>

                <Typography variant="body1" sx={{ mb: 2 }}>
                  Subtract Line 7 from Line 6 and enter the result as your Cost
                  of Goods Sold (COGS). Report this amount on the appropriate
                  line of your tax return (such as Form 1120, 1120-C, 1120-S,
                  1065, or 1120-F).
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 19, sm: 18, xs: 17 },
                    fontWeight: 600,
                    mb: 0.5,
                  }}
                >
                  Line 9a – Inventory Methods
                </Typography>
                <Typography variant="body1">
                  Check the applicable method used to value closing inventory:
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    <strong style={{ fontWeight: 600 }}> Cost:</strong>{' '}
                    Inventory is valued at purchase or production cost.
                  </li>
                  <li>
                    <strong style={{ fontWeight: 600 }}>
                      {' '}
                      Lower of Cost or Market:
                    </strong>{' '}
                    Inventory is valued at the lower of cost or market value.
                  </li>
                  <li>
                    <strong style={{ fontWeight: 600 }}> Other:</strong> Enter
                    the approved method used and attach an explanation.
                  </li>
                  <li>
                    <strong style={{ fontWeight: 600 }}>
                      {' '}
                      Alternative Methods (Small Businesses):
                    </strong>{' '}
                    Check the applicable method if using non-incidental
                    materials and supplies, AFS, or non-AFS inventory methods.
                  </li>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 19, sm: 18, xs: 17 },
                    fontWeight: 600,
                    mb: 0.5,
                  }}
                >
                  Line 9c – LIFO Method Adoption
                </Typography>

                <Typography variant="body1" sx={{ mb: 2 }}>
                  Check the box if you adopted the LIFO inventory method during
                  the tax year. Attach Form 970 if required.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 19, sm: 18, xs: 17 },
                    fontWeight: 600,
                    mb: 0.5,
                  }}
                >
                  Line 9d(i) – Closing Inventory Under LIFO
                </Typography>

                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the ending inventory value calculated using the LIFO
                  method.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 19, sm: 18, xs: 17 },
                    fontWeight: 600,
                    mb: 0.5,
                  }}
                >
                  Line 9d(ii) – LIFO Reserve
                </Typography>

                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the difference between the FIFO value and the LIFO value
                  of the ending inventory.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 19, sm: 18, xs: 17 },
                    fontWeight: 600,
                    mb: 0.5,
                  }}
                >
                  Line 9e – Section 263A Rules
                </Typography>

                <Typography variant="body1" sx={{ mb: 2 }}>
                  Check “Yes” if Section 263A capitalization rules apply to
                  inventory produced or acquired for resale.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 19, sm: 18, xs: 17 },
                    fontWeight: 600,
                    mb: 0.5,
                  }}
                >
                  Line 9f – Inventory Changes
                </Typography>

                <Typography variant="body1" sx={{ mb: 3 }}>
                  Check “Yes” if there is any change in determining inventory
                  quantities, costs, or valuations. Attach an explanation of the
                  change.
                </Typography>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Example Calculation Method
                </Typography>
                <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
                  The basic COGS formula used for Form 1125-A is:
                </Typography>
                <Typography variant="body1" sx={{ mb: 1, fontStyle: 'italic' }}>
                  Cost of Goods Sold = Beginning Inventory + Purchases + Direct
                  Costs − Ending Inventory
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  For example, if beginning inventory is $200,000, ending
                  inventory is $100,000, and direct costs incurred total
                  $50,000, COGS would be $150,000.
                </Typography>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="required"
                >
                  Required Documentation
                </Typography>

                <Box component="ul" sx={{ '& li': { mb: 1.5 }, mb: 4 }}>
                  <li>
                    Accurate inventory valuation (beginning and end of year).
                  </li>
                  <li>
                    Records of purchases, labor costs, freight, and other direct
                    expenses.
                  </li>
                  <li>
                    Details for Section 263A capitalized costs (when
                    applicable).
                  </li>
                  <li>Schedules for other costs, if needed. </li>
                </Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="common"
                >
                  Common Pitfalls and Penalties
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    mb: 1,
                  }}
                >
                  Failing to file Form 1125-A when required or submitting
                  unsubstantiated entries may result in:
                </Typography>
                <Box component="ul" sx={{ '& li': { mb: 1.5 }, mb: 4 }}>
                  <li>Financial penalties.</li>
                  <li>Additional IRS scrutiny or audits. </li>
                  <li>
                    Incorrect taxable income calculation and potentially
                    increased liability.{' '}
                  </li>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="key"
                >
                  Key Tips for Compliance
                </Typography>

                <Box component="ul" sx={{ '& li': { mb: 1.5 }, mb: 4 }}>
                  <li>
                    Maintain thorough records of inventory, purchases, and
                    production costs throughout the year.
                  </li>
                  <li>
                    Attach all supporting schedules required by IRS
                    instructions.
                  </li>
                  <li>
                    Review IRS updates each year for changes to methods,
                    deadlines, or additional documentation needs.
                  </li>
                  <li>
                    Seek professional tax counsel when implementing new
                    accounting methods or if COGS calculation is complex.
                  </li>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="faqs"
                >
                  Frequently Asked Questions (FAQs)
                </Typography>

                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  1. Do all businesses have to file Form 1125-A?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  No. Only businesses that sell or produce physical goods and
                  maintain inventory must file it.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  2. What inventory valuation methods are accepted by the IRS?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  You can use{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    FIFO (First-In, First-Out), LIFO (Last-In, First-Out)
                  </span>
                  , or the <span style={{ fontWeight: 600 }}>cost method</span>,
                  as long as it’s applied consistently each year.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  3. Can I e-file Form 1125-A separately?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  No. Form 1125-A is filed as part of your main business tax
                  return (Form 1120, 1120-S, or 1065). When you e-file your
                  return with TaxZerone, Form 1125-A will be automatically
                  included.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  4. What happens if I forget to file Form 1125-A?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  If you fail to include it when required, your return could be
                  considered incomplete, and your reported gross income may be
                  questioned by the IRS.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  5. Can service-based businesses file Form 1125-A voluntarily?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  No, the form only applies if your business maintains
                  inventory. Service-only entities should not file it.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Container maxWidth="lg" sx={{ mb: 5, my: { xs: 6, sm: 6, md: 6 } }}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={{ xs: 2, md: 5 }}
        >
          <Box
            sx={{
              width: '100%',
              textAlign: 'center',
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 2,
                textAlign: 'center',
                lineHeight: 1.5,
              }}
            >
              E-File Your Form 1120-S with TaxZerone
            </Typography>
            <Typography
              variant="h3"
              sx={{
                fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                fontWeight: 400,
                color: '#333333',
                mb: 2,
              }}
            >
              Simplify your S Corporation filing process with{' '}
              <span style={{ fontWeight: 600 }}> TaxZerone.</span>
            </Typography>
            <Typography
              variant="h3"
              sx={{
                fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                fontWeight: 400,
                color: '#333333',
                mb: 3,
              }}
            >
              With guided steps, built-in accuracy checks, and IRS
              authorization,{' '}
              <Hidden smDown>
                <br />
              </Hidden>{' '}
              you can e-file your Form 1120-S quickly and securely.
            </Typography>

            <Box sx={{ textAlign: { xs: 'center', md: 'center' } }}>
              <Button
                variant="contained"
                sx={{
                  mt: 1,
                  transition: 'all 0.3s ease 0s',
                  '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                }}
                className="btn-primary"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=1125a`}
              >
                Start E-Filing
              </Button>
            </Box>
          </Box>
        </Stack>
      </Container>
    </AppLayout>
  );
};

export default Form1125A;
